export const limitCharacters = (str: string, limit: number): string => {
  if (str.length > limit) {
    return `${str.substring(0, limit)}...`
  }
  return str
}

export const camelToSnakeCase = (camelCaseStr: string): string => camelCaseStr.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
